/**
 * Запросы к серверу для управления воспроизведением в плеере.
 */
var PlayerViewCmd;
(function (PlayerViewCmd) {
    /** Воспроизведение фильма по ID */
    PlayerViewCmd["PlayFilmById"] = "play-film-by-id";
    /** Воспроизведение видеоресурса по ID */
    PlayerViewCmd["PlayVideosourceById"] = "play-videosource-by-id";
    /** Воспроизведение файла по ID */
    PlayerViewCmd["PlayFileById"] = "play-file-by-id";
    /** Получить информацию о футаже */
    PlayerViewCmd["GetInfoByFootage"] = "get_info_by_footage";
    /** Воспроизвести футаж по ID */
    PlayerViewCmd["PlayFootageById"] = "play-footage-by-id";
    /** Сохранить изменённый футаж (варианты by-id/by-file — зависят от контроллера) */
    PlayerViewCmd["SaveChangedFootage"] = "save-changed-footage";
    PlayerViewCmd["SaveChangedFootageById"] = "save-changed-footage-by-id";
    /** Сохранить новый футаж */
    PlayerViewCmd["SaveNewFootage"] = "save-new-footage";
    PlayerViewCmd["SaveNewFootageByFile"] = "save-new-footage-by-file";
    /** Сохранить сцену на основе футажа */
    PlayerViewCmd["SaveSceneByFootage"] = "save-scene-by-footage";
    /** Поиск по похожему кадру */
    PlayerViewCmd["execSimilarSearch"] = "execSimilarSearch";
})(PlayerViewCmd || (PlayerViewCmd = {}));

export { PlayerViewCmd };
